export default __webpack_public_path__ + "assets/images/4b5b975c0e1ecc2e974c89e2aab7ce36.svg";